import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { d as defineCustomElement$2 } from './p-BbTg3Car.js';

const concatStyles = (...args) => {
    return args.filter(Boolean).join(' ');
};

const tileCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0;padding:0}:host p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;padding:0}:host(.header),:host(.header-button){border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:1.5rem}::slotted([slot=footer]){padding-left:1.5rem;padding-right:1.5rem}:host(.tabbed-header) wui-tabs{padding-left:1.5rem;padding-right:1.5rem;padding-top:.5rem}:host(.tile-container){background-color:var(--jw-theme-surface-tile-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;display:flex;flex-direction:column;max-width:100%;position:relative;width:100%}.horizontal-padding{padding-left:1.5rem;padding-right:1.5rem}.vertical-padding{padding-bottom:1.5rem;padding-top:1.5rem}";

const WuiTile$1 = /*@__PURE__*/ proxyCustomElement(class WuiTile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.hasHeader = false;
        this.hasFooter = false;
        this.fullWidth = false;
        this.fullHeight = false;
    }
    checkContentConfiguration() {
        this.hasFooter = slotFilled(this.elm, 'footer');
        this.hasHeader = slotFilled(this.elm, 'header');
    }
    componentDidLoad() {
        this.checkContentConfiguration();
    }
    render() {
        const boxProps = typeof this.box === 'object' ? this.box : {};
        return (h(Host, { key: '7d7c2753669cd190c53fc30e50e42c44ff8d7010', class: "tile-container" }, h("slot", { key: 'e955892c19ef85ed3530daa41fdec7ddf951fef8', name: "header" }), h("wui-box", { key: '9ac8e2dfe35c62cfc71bc753a7c9396172995df7', class: concatStyles(!this.hasFooter && !this.fullHeight && 'vertical-padding', (!this.hasHeader || !this.hasFooter) && !this.fullWidth && 'horizontal-padding'), style: { flex: '1' }, ...boxProps }, h("slot", { key: '68f908ad8c7794c2ab04a1cf2b0721e90d2f58d1' })), h("slot", { key: '59021a0c03b1fa393f774d88bc8c213ca412ad60', name: "footer" })));
    }
    get elm() { return this; }
    static get style() { return tileCss; }
}, [257, "wui-tile", {
        "fullWidth": [4, "full-width"],
        "fullHeight": [4, "full-height"],
        "box": [4],
        "hasHeader": [32],
        "hasFooter": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tile", "wui-box"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTile$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTile = WuiTile$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTile, defineCustomElement };
